/* eslint-disable i18next/no-literal-string */
import type { PartStatus } from "@/features/diagnostics/types";
import {
    PartStatusBadge,
    PartStatusBody,
    PartStatusImage,
    PartStatusImagePlaceholder,
    PartStatusImageWrapper,
    PartStatusItem as PartStatusItemRoot,
    PartStatusName,
    PartStatusPartNo,
} from "../lib/part-status-item.tsx";

type PartStatusItemProps = { part: PartStatus };

export default function PartStatusItem({ part }: PartStatusItemProps) {
    return (
        <PartStatusItemRoot status={!part.available ? "unavailable" : undefined}>
            <PartStatusImageWrapper>
                {part.image ? <PartStatusImage image={part.image} /> : <PartStatusImagePlaceholder />}
            </PartStatusImageWrapper>
            <PartStatusBody>
                <PartStatusName>{part.partName}</PartStatusName>
                <PartStatusPartNo>partNo: {part.partNo}</PartStatusPartNo>
            </PartStatusBody>
            <PartStatusBadge available={part.available} />
        </PartStatusItemRoot>
    );
}
